import { zl, isNumber } from "../../../functions/utilities";
import { adresPro2, findLokal, sortujLokale } from "../../../functions/ulice";
import WodaOdczytyUdzialyProcentyTHead from "./WodaOdczytyUdzialyProcentyTHead";
import WodaOdczytyUdzialyProcentyTFoot from "./WodaOdczytyUdzialyProcentyTFoot";
import { useEffect, useState } from "react";

const WodaOdczytyUdzialyProcenty = props => {

    const { wybraneRozliczenie, ulice, lokale, udzialyKontaAkt, grupy, mieszkancy, wybranyZakres } = props;
    
    const [zestaw, setZestaw] = useState([]);

    useEffect( () => {
        const temp = udzialyKontaAkt?.map( (udzialKonto, i) => {
                const proc = wybraneRozliczenie?.procenty?.find( p => p?.id_user == udzialKonto?.id_user && p?.grupa_numer == udzialKonto?.grupa_numer);
                const odczyt = wybraneRozliczenie?.odczytyWZakresie?.find( p => p?.id_user == udzialKonto?.id_user && p?.grupa_numer == udzialKonto?.grupa_numer);
                const adres = adresPro2(udzialKonto, lokale, ulice, grupy);
                const lokal = findLokal(udzialKonto, grupy, lokale);
                const mieszkaniec = mieszkancy?.find( m => m?.id_user == udzialKonto?.id_user)
            return ({
                udzialKonto,
                proc,
                odczyt,
                adres,
                lokal,
                ulicaId: lokal?.ulica,
                lokalNr: lokal?.numer,
                mieszkaniec
            })
        });
        setZestaw(sortujLokale(temp));
    }, [udzialyKontaAkt, wybraneRozliczenie, mieszkancy]);

    const lista = zestaw?.map( (element, i) => { 
        
        const { udzialKonto, proc, odczyt, adres, lokal, mieszkaniec } = element;

        const nieRozliczac = !proc?.czyRozliczac ? 'nie-rozliczac' : '';
        const brakZuzycia = proc?.zuzycieMieszkanca == 0 && nieRozliczac === ''?  'brak-odczytu' : ';'
        
        return  lokal && (
            <tr 
                key={i}
                className={ `${nieRozliczac}` }
            >
                <td style={{textAlign: 'left'}}>
                    {mieszkaniec?.imie_nazwisko} {`(id: ${udzialKonto.id_user} gr. ${udzialKonto.grupa_numer})`}
                </td>
                <td style={{textAlign: 'left'}}>
                    {adres}
                </td>
                <td>
                    {`${lokal?.metraz} m²`}
                </td>
                <td>
                    {`${isNumber(odczyt?.zimna_stan_poczatek) ? odczyt?.zimna_stan_poczatek : '-'} / ${isNumber(odczyt?.zimna_stan_koniec) ? odczyt?.zimna_stan_koniec : '-'}`}
                </td>
                <td>
                    {`${isNumber(odczyt?.ciepla_stan_poczatek) ? odczyt?.ciepla_stan_poczatek : '-'} / ${isNumber(odczyt?.ciepla_stan_koniec) ? odczyt?.ciepla_stan_koniec : '-'}`}
                </td>
                <td className={brakZuzycia}>
                    { proc ? `${proc?.zuzycieMieszkancaZimna} m³` : (<b>brak danych</b>) }
                </td>
                <td className={brakZuzycia}>
                    { proc ? `${proc?.zuzycieMieszkancaCiepla} m³` : (<b>brak danych</b>) }
                </td>
                <td>
                    {zl(proc?.kosztZimnej)}
                </td>
                <td>
                    {zl(proc?.abonament)}
                </td>
                <td>
                    {zl(proc?.podgrzanieWody)}
                </td>
                <td>
                    {zl(proc?.razemZwCwAbo)}
                </td>
                <td>
                    {zl(proc?.zaliczka_zw)}
                </td>
                <td>
                    {zl(proc?.zaliczka_abo_cw)}
                </td>
                <td>
                    {zl(proc?.zaliczka_cw)}
                </td>
                <td>
                    {zl(proc?.zaliczka_razem)}
                </td>
                <td>
                    {zl(proc?.strataMieszkancaKwota * -1)}
                </td>
                <td>
                    { proc ? `${proc?.strataMieszkancaMetry} m³ (${proc?.procMieszkanca}%)` : 'n / d'}
                </td>
                <td>
                    { zl( proc?.saldo ) }
                </td>
            </tr>
        )
    })

    return (
        <div className="woda-odczyty-procenty">
            <ul>
                <li className="ramka">
                    <table className="tabela">
                        <WodaOdczytyUdzialyProcentyTHead />
                        <tbody>
                            { wybranyZakres && (lista) }
                        </tbody>
                        {
                            wybranyZakres &&        (
                                <WodaOdczytyUdzialyProcentyTFoot
                                    wybraneRozliczenie={wybraneRozliczenie}
                                />
                            )
                        }
                    </table>
                </li>
            </ul>
        </div>
    )
}

export default WodaOdczytyUdzialyProcenty;